import { RouteObject } from 'react-router-dom'
import Login from './components/Login'
import Callback from './components/Callback'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import ForgotPassword from './components/ForgotPassword'

const AuthModule: RouteObject = {
    path: '',
    children: [
        {
            path: 'login',
            element: <Login />,
        },
        {
            path: 'callback',
            element: <Callback />,
        },
        {
            path: 'forgot',
            element: <ForgotPassword />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default AuthModule
